import React, { useContext, useState } from 'react';
import { DynamicComponent } from '@thd-nucleus/app-render';
import { QueryContext } from '@thd-nucleus/data-sources';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { Hydrator } from '@thd-olt-component-react/hydrator';
import proptypes from 'prop-types';
const { string, arrayOf, shape } = proptypes;
import classNames from 'classnames';
import {
  VendorCollectionProductsLoad,
  VendorCollectionProducts
} from '../dynamic-imports';
import { VendorCollectionDataModel } from '../VendorCollectionDataModel';
import { ProductsPlaceholder } from './placeholder/ProductsPlaceholder';
import { VendorCollectionSectionHeading } from './VendorCollectionSectionHeading';

export const VendorCollectionSection = ({
  section
}) => {
  const qctx = useContext(QueryContext);
  const [productCount, setProductCount] = useState(null);
  const collectionSectionStyle = classNames({
    'vendor-collection__products': productCount == null || productCount > 0
  });
  return (
    <div className={collectionSectionStyle}>
      {productCount > 0 && (
        <VendorCollectionSectionHeading sectionTitle={section.title} productCount={productCount} />
      )}
      <DynamicComponent pageType="collection">
        <Hydrator
          id={`collection-products-section__${section.title}`}
          delay={1000}
          scrollBuffer={400}
          preserveCtxVal="clientStore"
          waitFor={VendorCollectionProductsLoad}
          placeholder={(
            <ProductsPlaceholder />
          )}
        >
          <ErrorBoundary name="Products">
            <VendorCollectionProducts
              itemIds={section.products.map((prod) => prod.itemId)}
              setProductCount={setProductCount}
              qctx={qctx}
            />
          </ErrorBoundary>
        </Hydrator>
      </DynamicComponent>
    </div>
  );
};

VendorCollectionSection.displayName = 'VendorCollectionSection';

VendorCollectionSection.dataModel = VendorCollectionDataModel;

VendorCollectionSection.propTypes = {
  section: shape({
    title: string,
    products: arrayOf(shape({
      itemId: string
    }))
  }).isRequired
};